import React from 'react';
import { connect } from 'react-redux';
import styles from './Medication.module.css';
import { DBRadioButton, DBTextArea } from '_components';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class PatientCareCenterNoteWpSubjectiveMedication extends React.Component {

    handleMedsClick(selectedVal) {
        if (selectedVal === undefined || selectedVal === false ) {
            this.props.clearFields(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, ['EVSUBMEDCURRENT', 'EVSUBMEDS']);
        }
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='subj_meds' name='Medications &amp; Supplements' level={5}>
            <div className={styles.row}>
                <label className={styles.col1_wide}>Is the patient taking any medications?</label>
                <DBRadioButton
                    noteId={this.props.noteId}
                    entity='PTEVAL'
                    entityKeyColumn='EVNO'
                    entityKeyValue={this.props.evno}
                    field='EVSUBMEDTAKING'
                    className={styles.col2}
                    selectedValue={true}
                    label='Yes'
                    onClick={(selectedVal) => this.handleMedsClick(selectedVal)}
                />
                <DBRadioButton
                    noteId={this.props.noteId}
                    entity='PTEVAL'
                    entityKeyColumn='EVNO'
                    entityKeyValue={this.props.evno}
                    field='EVSUBMEDTAKING'
                    className={styles.col3}
                    selectedValue={false}
                    label='No'
                    onClick={(selectedVal) => this.handleMedsClick(selectedVal)}
                />
            </div>

            {this.props.takingMeds &&
                <div>
                    <div className={styles.row}>
                        <label className={styles.col1_wide}>Are meds for current condition?</label>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBMEDCURRENT'
                            className={styles.col2}
                            selectedValue={true}
                            label='Yes'
                        />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBMEDCURRENT'
                            className={styles.col3}
                            selectedValue={false}
                            label='No'
                        />
                    </div>

                    <div className={styles.row}>
                        <div className={styles.col1_top_req}>Medications:</div>
                        <DBTextArea
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBMEDS'
                            className={styles.textarea}
                        />
                    </div>


                </div>
            }

            <div className={styles.row}>
                <div className={styles.col1_top}>Supplements:</div>
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTEVAL'
                    entityKeyColumn='EVNO'
                    entityKeyValue={this.props.evno}
                    field='EVSUBMEDSUPPLEMENT'
                    className={styles.textarea}
                />
            </div>

        </PatientCareCenterNoteSection>

        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);

    return {
        noteId: noteId,
        evno: evno,
        takingMeds: state.entities.notes.PTEVAL[evno].EVSUBMEDTAKING ? state.entities.notes.PTEVAL[evno].EVSUBMEDTAKING : false
    };
}

const connectedPatientCareCenterNoteWpSubjectiveMedication = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteWpSubjectiveMedication);
export { connectedPatientCareCenterNoteWpSubjectiveMedication as PatientCareCenterNoteWpSubjectiveMedication };

